import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import classNames from 'classnames'
import { useForm, useValue } from '@morningtrain/react-resources'

export default function EditInventoryNormIndexQuantity ({
  max = 100,
  min = null,
  className
}) {
  const form = useForm()
  const modelIndex = useValue('active_index')
  const [activeIndex, setActiveIndex] = useEnvValue('globals.inventory.norms.active_index', modelIndex)

  const [internalValue, setInternalValue] = React.useState(activeIndex)

  React.useEffect(() => {
    // handleValueChange(activeIndex)
  }, [activeIndex])

  React.useEffect(() => {
    setActiveIndex(modelIndex)
    setInternalValue(modelIndex)
  }, [modelIndex])

  React.useEffect(() => {
    if (activeIndex !== internalValue) {
      setActiveIndex(internalValue)
    }
  }, [internalValue])

  const handleValueChange = (newValue) => {
    if (newValue === null) {
      setInternalValue(null)
      return
    }

    newValue = parseInt(newValue)

    if (isNaN(newValue)) {
      newValue = 0
    }

    if (min !== null) {
      newValue = Math.max(min, newValue)
    }

    if (max !== null) {
      newValue = Math.min(max, newValue)
    }

    if (newValue !== internalValue) {
      form.setAsChanged()
      setInternalValue(newValue)
    }
  }

  const _className = classNames(
    'quantity-input',
    'h-full m-1',
    { yellow: internalValue !== modelIndex }, /// Edited - not saved
    { dark: internalValue === modelIndex }, /// Edited - saved
    className
  )

  return (
    <div className={_className}>
      <div className='quantity-input-border'>
        <div onClick={() => handleValueChange(internalValue - 1, true)} className='quantity-input__btn-wrap'>
          <button type='button'>-</button>
        </div>

        <div className='quantity-input__text'>
          <input
            name='active_index'
            value={internalValue !== null ? internalValue : ''}
            onChange={e => handleValueChange(e.target.value)}
          />
        </div>

        <div onClick={() => handleValueChange(internalValue + 1, true)} className='quantity-input__btn-wrap'>
          <button type='button'>+</button>
        </div>
      </div>
    </div>
  )
}
